
























































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import { MarcacoesHoje, diasSemana, marcacaoPresenca } from "@/plugins/utils/marcacaoUtils";
import { conection, LongPollLog } from '@/plugins/utils/conectionUtils';
import { copyArrayJson, nl2br, timeStringToTime } from '@/plugins/utils/utils';
import { checkTratamentoAux, Tratamentos } from '@/plugins/utils/consultaUtils';
// import { DiaSemana, DiaSemanaObject, diasSemana, getMapasHelpers } from '@/plugins/utils/marcacaoUtils';


@Component({
  components: {
    TitleArea
  }
})
export default class Timeline extends Vue {

  titleArea = "Timeline";
  id_terapeuta: number | null = null;
  marcacoes: MarcacoesHoje[] = [];
  created(){
    if(this.$route.params.id_terapeuta){
      this.id_terapeuta = parseInt(this.$route.params.id_terapeuta);
    }

    this.$store.commit("setLoading", true);
    this.getTimeline();
  }

  idErrorHandler(): void{
    this.$store.commit("setLoading", false);
    this.$store.commit("setError", {flag: true, text: "Terapeuta inválido", status: "error"});
    this.$router.push("/terapeutas");
  }
  
  long_poll: LongPollLog | null = null;
  declareLongPoll(last_log_id: number){
    if(!this.long_poll){
      this.long_poll = new LongPollLog(last_log_id, this.getTimeline);
    }
  }
  destroyLongPoll(){
    if(this.long_poll){
      this.long_poll.cancel();
    }
    this.long_poll = null;
  }
  destroyed(){
    this.destroyLongPoll();
  }
  getTimeline(): void{
    conection(
      "getTimeline.php",
      {id_terapeuta: this.id_terapeuta},
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (resp: {terapeuta: string; marcacoes: any[]; last_log_id: number}) => {
        // console.log(resp.marcacoes);
        if(this.id_terapeuta){
          const dayWeek = new Date().getDay();
          if(
            resp.marcacoes[this.id_terapeuta] && 
            diasSemana[dayWeek-1] && 
            resp.marcacoes[this.id_terapeuta][ diasSemana[dayWeek-1].value ]
          ){
            
            this.marcacoes = copyArrayJson(resp.marcacoes[this.id_terapeuta][ diasSemana[dayWeek-1].value ]);
          }
        }
        if(resp.terapeuta){
          this.titleArea = resp.terapeuta; 
        }
        this.$store.commit("setLoading", false);

        this.declareLongPoll(resp.last_log_id ? resp.last_log_id : 1);

        if(this.long_poll){
          this.long_poll.cancel();
          this.long_poll.setCounter(1000);
        }
      },
      () => {
        this.$store.commit("setLoading", false);
      }
    )
  }

  nl2brLocal(text: string): string{
    return nl2br(text, false);
  }
  get marcacoesTimeline(): MarcacoesHoje[]{
    return this.marcacoes;
  }

  marcacaoPresenca(item: MarcacoesHoje): void{
    this.$store.commit("setLoading", true);
    marcacaoPresenca(
      item.id,
      item.status,
      item.data,
      () => {
        let string_feedback = "Presença assinalada";
        if(item.status == 0) string_feedback = "Presença retirada"; 
        this.$store.commit("setError", {flag: true, text: string_feedback, status: "success"});
        this.getTimeline();
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Ocorreu um erro a assinalar/retirar a presença! Tente de novo", status: "error"});
        this.$store.commit("setLoading", false);
        item.status = item.status*(-1)+1;
      }
    );
  }

  checkTimePassed(time_string: string): boolean{
    const time = timeStringToTime(time_string);
    const nowDate = new Date();
    nowDate.setMinutes( nowDate.getMinutes() - 30 );
    const now = nowDate.getTime();
    if(time < now){
      return true;
    }
    else {
      return false;
    }
  }

  // mounted(){
  //   // setTimeout(() => {
      
  //   //   this.checkHour();
  //   // }, 1000);
  // }
  flag_ini = true;
  updated(){
    if(this.flag_ini){
      this.checkHour();
      this.flag_ini = false;
    }
  }

  changePointsForUnderscor(horas: string): string{
    const h = horas.split(":");
    let new_horas = "";
    h.forEach(item => {
      new_horas += item;
    });
    return new_horas;
  }

  checkHour(): void {
    const nowDate = new Date();
    // nowDate.setMinutes( nowDate.getMinutes() - 30 );
  
    const hours = nowDate.getHours();  
    const min_hour = this.foundElementByHour(hours, nowDate.getMinutes());
    

    if(min_hour){
      const elem_final = document.getElementById(min_hour);
      if(elem_final){
        // elem.scrollIntoView({behavior: "smooth", block: "start"});
        const headerOffset = 65;
        const elementPosition = elem_final.getBoundingClientRect().top;
        const offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
      }
    }
  }


  foundElementByHour(hour: number, minutes: number): string | false{
    
    let hourString = hour+"";
    if(hour < 10) hourString = "0"+hour;
    
    const min_min = this.foundElementByMinutes(hourString, minutes);
    let minutes_string = "00";
    if(min_min){
      minutes_string = min_min;
    }
    const elem = document.getElementById(hourString + minutes_string);
    if(elem){
      return hourString+minutes_string;
    }
    else {
      if(hour-1 < 6){
        return false;
      }
      else return this.foundElementByHour(hour-1, 59);
    }
  }

  foundElementByMinutes(hour_string: string, minutes: number): string | false{
    let minutes_string = minutes + "";
    if(minutes < 10) minutes_string =  "0" + minutes_string;
    const elem = document.getElementById(hour_string + minutes_string);
    if(elem){
      return minutes_string;
    }
    else {
      if(minutes-1 < 0){
        return false;
      }
      else return this.foundElementByMinutes(hour_string, minutes-1);
    }
  }

  tratamentosDividedDinamico(tratamento: string): Tratamentos | null{
    if(tratamento){
      return checkTratamentoAux(tratamento, this.$store.getters.separatorAux);
    } else {
      return null;
    }
  }
}
